(function () {
    $(document).ready(function () {
        let rules = {
            name: {required: true, minlength: 3, maxlength: 100},
            email: {required: true, email: true},
            phone: {required: true, digits: true, minlength: 6, maxlength: 9},
            message: {required: true, minlength: 10, maxlength: 3000},
        };
        let messages = {
            name: {
                required: "Nombre Requerido",
                maxlength: "El nombre ingresado es muy grande, máximo 100 caracteres"
            },
            email: {
                required: "Ingrese un correo electrónico válido",
                email: "Formato de correo electrónico incorrecto"
            },
            phone: {
                required: "Ingrese un número de celular",
                digits: "Ingrese solo números, sin espacios",
                minlength: "Ingrese un formato válido entre 6 a 9 dígitos",
                maxlength: "Ingrese un formato válido entre 6 a 9 dígitos."
            },
            message: {
                required: "Ingrese un mensaje",
                minlength: "Ingrese un mensaje con mas detalle",
                maxlength: "Máximo 3 mil caracteres."
            },
        };

        $(".contactos_section #email_form").submit(function (e) {
            e.preventDefault();
        }).validate({
            rules: rules,
            messages: messages,
            submitHandler: function (form) {
                enableLoadingButton();
                $(".contactos_section #email_form").request('onSend', {
                    success: function (data) {
                        showInfoPanel('success', "Se envió su mensaje correctamente.");
                        resetForm();
                        disableLoadingButton();
                    },
                    error: function (error) {
                        showInfoPanel('error', "Hubo un problema para enviar su correo, intentelo mas tarde.");
                        resetForm();
                        disableLoadingButton();
                    }
                });
                return false;
            }
        });

        function enableLoadingButton() {
            $(".contactos_section #email_form").find('button')
                .attr('disabled', 'disabled')
                .html("Enviando ... ")
                .addClass('inactive')
        }

        function disableLoadingButton() {
            $(".contactos_section #email_form").find('button')
                .removeAttr('disabled')
                .html("Enviar")
                .removeClass('inactive')
        }

        function resetForm() {
            $(".contactos_section #email_form").find('input:text, textarea').val('');
        }

        function showInfoPanel(state, message) {
            let $message = $('.contactos_section #email_form .state-info-panel .message');
            $message.html(message).addClass(state);
            setTimeout(function () {
                $message.removeClass(state)
            }, 5000);
        }
    });
})();